import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MediaService } from '../media-service.service';

@Component({
  selector: 'app-select-media',
  templateUrl: './select-media.component.html',
  styleUrls: ['./select-media.component.scss']
})
export class SelectMediaComponent implements OnInit, OnChanges {

  @Input() newUpdatedMedia;
  @Input() formatsAllowed: string;
  @Output() onFileSelect = new EventEmitter();

  media: any[] = [];
  allowedMedia: any[] = [];
  environment = environment;

  constructor(
    private mediaService: MediaService
  ) { }

  ngOnInit(): void {

    this.mediaService.getAllMedia()
    .subscribe((res: {data: any[]}) => {
      this.media = res.data;
      this.getAllowedMedia();
    });
  }

  ngOnChanges(): void {
    if (this.newUpdatedMedia) {
      this.media.push(this.newUpdatedMedia);
    }
  }

  deleteImage(media): void {
    // TODO: chiamata per eliminare media da server
    this.mediaService.deleteImage(media.id)
    .subscribe((res: any) => {
      this.media = this.media.filter(m => +m.id !== +media.id);
      this.getAllowedMedia();
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

  selectFile(media): void {
    this.onFileSelect.emit(media);
  }

  fileImage(media: any): string {
    let fileImage = '';
    switch (media.mimetype) {
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/png':
        fileImage = environment.imageCDN + environment.imageFolder + '/' + media.filename;
        break;
      case 'audio/mp3':
      case 'audio/mpeg':
      case 'audio/wav':
        fileImage = '/assets/images/' + 'audio.png';
        break;
      default:
        break;
    }
    return fileImage;
  }

  getAllowedMedia(): void {
    if (this.formatsAllowed !== undefined) {
      this.allowedMedia = this.media.filter(f => f.filename.search(this.formatsAllowed.split(',').join('|')) !== -1);
    } else {
      this.allowedMedia = this.media.filter(f => f.filename.search('jpeg|jpg|png') !== -1);
    }
  }

}
